import axios from "axios";

//const baseURL = 'https://bdgwhapi.azurewebsites.net/api'
const baseURL = "https://seranovaapi.azurewebsites.net/api";

const connection = axios.create({
  baseURL: baseURL,
});

connection.interceptors.request.use((config) => {
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "*/*",
  };
  return config;
});

export default connection;
